import Vue from "vue";
import Router from "vue-router";

import index from "@/components/index";
import building from "@/components/common/building";

/*板块*/
import info from "@/components/info/index";
import tour from "@/components/tour/index";
import service from "@/components/service/index";

/*子路由*/
import infochildren from "@/router/info/";
import tourchildren from "@/router/tour/";
import servicechildren from "@/router/service/";
import exb from "@/components/exb"


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "404",
      component: index,
      meta: {
        title: "宜昌博物馆"
      }
    },
    {
      path: "/index",
      name: "index",
      component: index,
      meta: {
        title: "首页 - 宜昌博物馆"
      }
    },
     {
      path: "/exb",
      name: "exb",
      component: exb,
      meta: {
        title: "首页 - 馆藏精品"
      }
    },
    {
      path: "/common/building",
      name: "building",
      component: building,
      meta: {
        title: "正在建设中"
      }
    },
    {
      path: "/info",
      name: "info",
      component: info,
      meta: {
        title: "资讯服务"
      },
      children: [...infochildren]
    },
    {
      path: "/tour",
      name: "tour",
      component: tour,
      meta: {
        title: "导览讲解"
      },
      children: [...tourchildren]
    },
    {
      path: "/service",
      name: "service",
      component: service,
      meta: {
        title: "参观服务"
      },
      children: [...servicechildren]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js